import React, { useEffect, useState } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import { apiHandler } from '../../api/apihandler';
import { CMS_DETAILS } from '../../api/constants';
import PeopleYouMayKnowWidget from './PeopleYouMayKnowWidget';
import MyStatsWidget from './MyStatsWidget';
import '../../views/dashboard/social/social-list-page.css';
import './static-page.css';

// Shared nemonto-themed shell for the CMS-backed info pages (About Us,
// Privacy Policy, Terms of Use) - same CMS_DETAILS(slug) fetch + body
// rendering the old Bootstrap versions used. Follows the same two-column
// "home screen" layout (.nmsl-layout main + right rail with the People You
// May Know / Your Activity widgets) as the other nemonto dashboard pages -
// the Sidebar nav is the way back, no in-page back button.
const StaticCmsPage = ({ slug, title, subtitle }) => {
  const [sections, setSections] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      setLoading(true);
      try {
        const res = await apiHandler(CMS_DETAILS, 'POST', { slug });
        if (isMounted && res?.data?.response?.status === 200) {
          setSections(res?.data?.data?.cmsPage?.cms_page_body || []);
        }
      } catch (e) {
        console.error(e);
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => { isMounted = false; };
  }, [slug]);

  return (
    <div className="nmsl-layout">
      <div className="nmsl-main">
        <div className="nmsl-page-header">
          <div className="nmsl-header">
            <h3 className="nmsl-title">{title}</h3>
          </div>
          {subtitle && <p className="nmsl-subtitle">{subtitle}</p>}
        </div>

        <div className="nmsl-main-body">
          <div className="nmsp-card">
            {loading ? (
              <p className="nmsl-loading">Loading…</p>
            ) : sections && sections.length > 0 ? (
              sections.map((elm, i) => (
                <section key={elm?.id || i} className="nmsp-section">
                  {elm?.heading && <h2>{elm.heading}</h2>}
                  <div className="nmsp-body" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(elm?.description || '') }} />
                </section>
              ))
            ) : (
              <p className="nmsl-empty-note">Nothing to show here yet.</p>
            )}
          </div>
        </div>
      </div>

      <aside className="nmsl-rail">
        <PeopleYouMayKnowWidget />
        <MyStatsWidget />
      </aside>
    </div>
  );
};

export default StaticCmsPage;
